export const state = () => ({
  kycaidStatus: {},
  deepLink: {},
  userStatus: {},
  dateEnd: 0,
})

export const mutations = {
  setKycaidStatus(state, data) {
    state.kycaidStatus = data
  },

  setDeepLink(state, data) {
    state.deepLink = data
    state.dateEnd = data.end_date
  },

  setUserStatus(state, data) {
    state.userStatus = data
  },
}

export const actions = {
  async kycaidStatus({ commit }) {
    try {
      const res = await this.$api.kycaid.getKycaidStatus()
      commit('setKycaidStatus', res.data)
    }
    catch (err) {
      console.log(err)
    }
  },

  async deepLinkKycaid({ commit }) {
    try {
      const res = await this.$api.kycaid.getDeepLinkKycaid()
      commit('setDeepLink', res.data)
    }
    catch (err) {
      console.log(err)
    }
  },

  async userStatus({ commit }) {
    if (!this._lastUserStatusRequestTime) {
      this._lastUserStatusRequestTime = 0
    }

    const now = Date.now()
    const delayMs = 300

    if (now - this._lastUserStatusRequestTime < delayMs) {
      return
    }

    this._lastUserStatusRequestTime = now

    try {
      const res = await this.$api.kycaid.getUserStatusKycaid()
      commit('setUserStatus', res.data)
    }
    catch (err) {
      console.error('Error fetching user status:', err)
    }
  },
}

export const getters = {
  getKycaidStatus: state => state.kycaidStatus,
  getDeepLink: state => state.deepLink,
  getUserStatus: state => state.userStatus,
  getDateEnd: state => state.dateEnd,
}
